module.exports = __webpack_public_path__ + "img/exam (1).94ca1965.png";